import { ImmutableVector3 } from '@modugen/ui-toolkit'

type PointLoadDirectionElement = ShapeObject | ShapeObjectLine | Rip | Lintel

const GLOBAL_X = new ImmutableVector3(1, 0, 0)

const isWallElement = (element: PointLoadDirectionElement | undefined): element is ShapeObject =>
  element?.element_type === 'outer_walls' || element?.element_type === 'inner_walls'

const wallAxisTextXDirection = (wall: ShapeObject): ImmutableVector3 => {
  const shape = wall.shape as PolygonShape
  const direction = shape.points[1].sub(shape.points[0]).normalize()
  if (direction.x < 0 && direction.y < 0) {
    return direction.multiplyScalar(-1)
  }
  return direction
}

const ripWallTextXDirection = (
  wallGuid: string | undefined,
  guidToElement: Record<string, PointLoadDirectionElement>,
): ImmutableVector3 => {
  const wall = wallGuid ? guidToElement[wallGuid] : undefined
  return isWallElement(wall) ? wallAxisTextXDirection(wall) : GLOBAL_X
}

export const getElementDirectionForTextDirection = (
  elementGuid: string,
  guidToElement: Record<string, PointLoadDirectionElement>,
  positionGuidToWallGuid: Record<string, string> = {},
): ImmutableVector3 => {
  const element = guidToElement[elementGuid]

  if (element?.element_type === 'rips' && 'wall_guid' in element) {
    return ripWallTextXDirection(element.wall_guid, guidToElement)
  }

  if (!element) {
    return ripWallTextXDirection(positionGuidToWallGuid[elementGuid], guidToElement)
  }

  if (element.element_type === 'outer_walls' || element.element_type === 'inner_walls') {
    const shape = element.shape as PolygonShape
    return shape.points[1].sub(shape.points[0]).normalize()
  } else if (element.element_type === 'beams' || element.element_type === 'purlins') {
    const shape = element.shape as LineShape
    return shape.end.sub(shape.start).normalize()
  } else if (element.element_type === 'lintels') {
    const shape = element as Lintel
    return shape.end.sub(shape.start).normalize()
  } else if (element.element_type === 'slab_beams' || element.element_type === 'roof_slab_beams') {
    const shape = element.shape as LineShape
    return shape.end.sub(shape.start).normalize()
  } else if (
    element.element_type === 'vertical_slabs' ||
    element.element_type === 'vertical_roof_slabs'
  ) {
    const shape = element.shape as PolygonShape
    return shape.points[2].sub(shape.points[1]).normalize()
  }
  return GLOBAL_X
}
